import { Injectable } from '@nestjs/common';
import {ExpensesSubCategoryDTO} from './expenses-sub-category.dto';
import {ExpensesSubCategory} from '../expenses-sub-category.entity';
import { ExpensesCategory } from '../../expenses-category/expenses-category.entity';


@Injectable()
export class ExpensesSubCategoryAdapter {
  
  public convertDtoToEntity(expensesSubCategoryDTO: ExpensesSubCategoryDTO,  isUpdate: boolean = false ): ExpensesSubCategory {
    const expensesSubCategories = new ExpensesSubCategory();
    expensesSubCategories.expensesSubCategoryId=expensesSubCategoryDTO.expensesSubCategoryId;
    expensesSubCategories.expensesSubCategory=expensesSubCategoryDTO.expensesSubCategory;
    expensesSubCategories.expensesCategoryInfo = new ExpensesCategory();
    expensesSubCategories.expensesCategoryInfo.expensesCategoryId=expensesSubCategoryDTO.expensesCategoryId;
    expensesSubCategories.expensesCategoryInfo.expensesCategory=expensesSubCategoryDTO.expensesCategory;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    expensesSubCategories.isActive=expensesSubCategoryDTO.isActive==undefined?true:expensesSubCategoryDTO.isActive;
    if (isUpdate) {
        expensesSubCategories.updatedUser = expensesSubCategoryDTO.updatedUser;
    } else {
        expensesSubCategories.isActive = true;
        expensesSubCategories.createdUser = expensesSubCategoryDTO.createdUser;
    }
   return expensesSubCategories;
  }
  public convertEntityToDto(expensesSubCategoryObject: ExpensesSubCategory): ExpensesSubCategoryDTO {
    const expensesSubCategoryDto= new ExpensesSubCategoryDTO;
    expensesSubCategoryDto.expensesSubCategoryId=expensesSubCategoryObject.expensesSubCategoryId;
    expensesSubCategoryDto.expensesSubCategory=expensesSubCategoryObject.expensesSubCategory;
    expensesSubCategoryDto.expensesCategoryId=(expensesSubCategoryObject.expensesCategoryInfo)?.expensesCategoryId;
    expensesSubCategoryDto.expensesCategory=(expensesSubCategoryObject.expensesCategoryInfo)?.expensesCategory
    expensesSubCategoryDto.isActive = expensesSubCategoryObject.isActive;
    expensesSubCategoryDto.createdAt = expensesSubCategoryObject.createdAt;
    expensesSubCategoryDto.updatedAt = expensesSubCategoryObject.updatedAt;
    expensesSubCategoryDto.createdUser = expensesSubCategoryObject.createdUser;
    expensesSubCategoryDto.updatedUser = expensesSubCategoryObject.updatedUser;
    expensesSubCategoryDto.versionFlag = expensesSubCategoryObject.versionFlag;
    return expensesSubCategoryDto;
  }
}
